import { motion } from "framer-motion";

export default function Chapter({ number, title, dark, plum, children }) {
  return (
    <motion.section
      data-testid={`chapter-${number}`}
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className={`relative overflow-hidden px-6 py-24 sm:py-32 ${
        dark
          ? "zulu-emboss bg-[#4A3B32] text-[#FAF8F5]"
          : plum
            ? "bg-[#5A3A5A] text-[#FAF8F5]"
            : "bg-[#FAF8F5] text-[#4A3B32]"
      }`}
    >
      <div className="relative mx-auto max-w-3xl">
        <span
          aria-hidden="true"
          className={`pointer-events-none absolute -top-14 right-0 select-none font-serif-lux text-[7rem] leading-none sm:-top-20 sm:text-[10rem] ${
            dark || plum ? "text-[#C5A059]/15" : "text-[#5A3A5A]/15"
          }`}
        >
          {number}
        </span>
        <p
          className={`text-[10px] uppercase tracking-[0.4em] ${
            dark || plum ? "text-[#C5A059]" : "text-[#5A3A5A]"
          }`}
        >
          Chapter {number}
        </p>
        <h2 className="mt-3 font-serif-lux text-3xl font-medium tracking-tight sm:text-4xl">
          {title}
        </h2>
        <div className="mt-4 h-px w-16 bg-[#C5A059]/70" />
        <div
          className={`mt-8 space-y-5 text-sm leading-relaxed sm:text-base ${
            dark || plum ? "text-[#FAF8F5]/85" : "text-[#4A3B32]/90"
          }`}
        >
          {children}
        </div>
      </div>
    </motion.section>
  );
}
